import { client } from '../http';

export default {
  async saveInputs(inputs) {
    await client.post('/api/save-inputs', { inputs });
  },
};
